<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-back-button default-href="/newCrawlLocation"></ion-back-button>
        </ion-buttons>
        <ion-title>New Crawl</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <ion-grid>
        <ion-row>
          <ion-col>
            <ion-text color="--ion-color-primary-contrast">
              <h1 style="margin-bottom: 0; text-align: center"><strong>How long at each bar?</strong></h1>
            </ion-text>
          </ion-col>
        </ion-row>
      </ion-grid>
      <ion-grid style="display: flex; flex-direction: row; justify-content: space-around">
        <ion-row>
          <ion-col>
            <ion-button expand="block"  size="large" fill="solid" strong  @click="setNewBarDurationAndCreateCrawl(30)" :disabled="creatingGame" data-cypress="duration-30">30 min</ion-button>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <ion-button expand="block"  size="large" fill="solid" strong  @click="setNewBarDurationAndCreateCrawl(45)" :disabled="creatingGame">45 min</ion-button>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <ion-button expand="block" size="large" fill="solid" strong  @click="setNewBarDurationAndCreateCrawl(60)" :disabled="creatingGame">1 hr</ion-button>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
  </ion-page>
</template>

<script>
import {
  IonBackButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonCol,
  IonGrid,
  IonRow,
  IonText,
} from '@ionic/vue';
import { warning } from 'ionicons/icons';
import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';
import { Plugins } from '@capacitor/core';
import { WonderPush } from '@ionic-native/wonderpush/ngx';
import * as apiMethods from '../app/api.js';

export default defineComponent({
  name: 'NewCrawlBarDuration',
  components: {
    IonBackButton,
    IonButtons,
    IonContent,
    IonHeader,
    IonPage,
    IonTitle,
    IonToolbar,
    IonCol,
    IonGrid,
    IonRow,
    IonText,
  },
  setup() {
    const { Storage, Device } = Plugins;

    //const wonderPush = new WonderPush;
    apiMethods.crawlApi.WonderPush = WonderPush;
    apiMethods.crawlApi.Device = Device;
    apiMethods.crawlApi.Storage = Storage;
    return {  warning,
              console,
              router: useRouter(),
              Storage,
              Device }
  },
  mounted: async function() {
    console.log('Mounted.');
    apiMethods.crawlApi.init();
  },
  data:
    function() {
      return {
        creatingGame: false
      };
    }
  ,
  methods: {
    setNewBarDurationAndCreateCrawl: async function(duration) {
      this.creatingGame = true;
      await apiMethods.crawlApi.setNewBarDurationAndCreateCrawl(duration);
      this.creatingGame = false;
      this.router.push('/new-crawl-ready');
    },
  }
});
</script>

<style scoped>

</style>